// services/api/cartService.js
import axios from "axios";
import { API_URL } from "@/config/env";
import { toast } from "react-hot-toast";

export const addToCart = async (itemId, addOnSelected) => {
  try {
    const mesaId = localStorage.getItem("mesaId");
    if (!mesaId) {
      localStorage.setItem("mesaId", "15"); // Valor por defecto si no existe
      toast.error("No se encontró la mesa, usando mesa por defecto");
    }

    const finalMesaId = localStorage.getItem("mesaId");
    console.log("[CartService] Adding to cart:", {
      mesaId: finalMesaId,
      itemId,
      addOnSelected,
    });

    const response = await axios.post(`${API_URL}/api/cart/add`, {
      mesaId: finalMesaId,
      foodItemId: itemId,
      data: addOnSelected,
    });

    return response.data;
  } catch (error) {
    console.error("[CartService] Error adding to cart:", error);
    if (error.response?.status === 400) {
      toast.error(
        "Error al agregar al carrito: " + error.response.data.message
      );
    } else {
      toast.error(
        "Error al agregar al carrito. Por favor, intente nuevamente."
      );
    }
    throw error;
  }
};
